import { CatBadge } from '@blocks-react/components/Badge';
import { ProductCardBadgeProps } from '../types';

export const ProductStockBadge = ({ label }: ProductCardBadgeProps) => {
  return <CatBadge size="md" variant="grey" text={label}></CatBadge>;
};
